import { FC, memo } from 'react';
import { Link as RouterLink } from 'react-router';
import { Box, Link, Stack } from '@chakra-ui/react';

import { NavProps } from './types/NavProps';

const DesktopNavComponent: FC<NavProps> = ({ navItems }) => (
  <Stack alignItems="center" direction="row">
    {navItems.map((navItem) => (
      <Box key={navItem.label}>
        <Link
          _hover={{ textDecoration: 'none' }}
          asChild
          borderBottomStyle="solid"
          borderBottomWidth={3}
          layerStyle={navItem.selected ? 'headerNavSelected' : 'headerNavBase'}
          px={4}
          py={6}
          textDecoration="none"
        >
          <RouterLink to={navItem.href}>{navItem.label}</RouterLink>
        </Link>
      </Box>
    ))}
  </Stack>
);

export const DesktopNav = memo(DesktopNavComponent);
